import { useNavigate } from "react-router-dom";
import "../../assets/css/product.scss";
import DonationStep2Component from "../../components/donation/step2_component";
import { useEffect } from "react";
import { SessionStorageUtil } from "../../utils/session_storage_util";

function DonationStep2Page() {
  const navigate = useNavigate();

  useEffect(() => {
    if (!SessionStorageUtil.getItem("accessToken")) {
      navigate("/donation_step1", { replace: true });
    }
  }, [navigate]);

  if (!SessionStorageUtil.getItem("accessToken")) {
    return null;
  }

  return <DonationStep2Component />;
}

export default DonationStep2Page;
